<template>
    <div>
        <h4 class="is-size-4">Contenido</h4>
        <ol>
            <li class="is-size-5">
                <a href="/sepomex/municipios/#municipios">Municipios</a>
            </li>
            <li class="is-size-5">
                <a href="/sepomex/municipios/#municipio">Municipio</a>
            </li>
        </ol>
        <br>

        <h3 class="is-size-4" id="municipios">1.- Municipios</h3>
        <strong>Enpoint con la lista de municipios, siempre regresa un array de objetos, incluso aunque sea solo un elemento</strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/municipios/</code>
        </p>

        <h5 class="is-size-6">Parametros opcionales para busqueda:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>id</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 282)</li>
                    </ul>
                </li>
                <li>
                    <strong>stateId</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 8)</li>
                    </ul>
                </li>
                <li>
                    <strong>stateCode</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 08)</li>
                    </ul>
                </li>
                <li>
                    <strong>locationName</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. chihuahua)</li>
                    </ul>
                </li>
                <li>
                    <strong>locationCode</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 00919003)</li>
                    </ul>
                </li>
                <li>
                    <strong>inegiLocationCode</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 080190001)</li>
                    </ul>
                </li>
                <li>
                    <strong>activo</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato boolean (Ej. true, 1, yes, false, 0, no)</li>
                    </ul>
                </li>
                <li>
                    <strong>sepomex</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato boolean (Ej. true, 1, yes, false, 0, no)</li>
                    </ul>
                </li>
                <li>
                    <strong>nombre</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 'chihuahua' )</li>
                    </ul>
                </li>
            </ul>
        </div>

       
        <h5 class="is-size-6 has-text-weight-bold">Respuesta 1 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/municipios?stateId=8&activo=1</h5>
            <code>[
                {
                    "id": 309,
                    "stateId": 8,
                    "nombre": "JIMÉNEZ",
                    "stateCode": "08",
                    "locationName": "JIMÉNEZ",
                    "locationCode": "00936009",
                    "inegiLocationCode": "080360001",
                    "sepomex": true,
                    "activo": true
                },
                {
                    "id": 300,
                    "stateId": 8,
                    "nombre": "GUACHOCHI",
                    "stateCode": "08",
                    "locationName": "GUACHOCHI",
                    "locationCode": "00927009",
                    "inegiLocationCode": "080270001",
                    "sepomex": true,
                    "activo": true
                },
                {
                    "id": 343,
                    "stateId": 8,
                    "nombre": "SAUCILLO",
                    "stateCode": "08",
                    "locationName": "SAUCILLO",
                    "locationCode": "00962006",
                    "inegiLocationCode": "080620001",
                    "sepomex": true,
                    "activo": true
                },
                ...
            ]</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 2 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/municipios?inegiLocationCode=080190001</h5>
            <code>[
                {
                    "id": 271,
                    "stateId": 8,
                    "nombre": "AVALOS",
                    "stateCode": "08",
                    "locationName": "AVALOS",
                    "locationCode": "00919113",
                    "inegiLocationCode": "080190001",
                    "sepomex": false,
                    "activo": false
                },
                {
                    "id": 282,
                    "stateId": 8,
                    "nombre": "CHIHUAHUA",
                    "stateCode": "08",
                    "locationName": "CHIHUAHUA",
                    "locationCode": "00919003",
                    "inegiLocationCode": "080190001",
                    "sepomex": true,
                    "activo": true
                }
            ]</code>
        </pre>
        <hr />

        <h3 class="is-size-3" id="municipio">2.- Municipio</h3>
        <strong>Enpoint con el detalle de un solo municipio, siempre regresa un objeto.</strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/municipio/{id}</code>
        </p>

        <h5 class="is-size-6">Parametros:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>id</strong>
                    <ul>
                        <li>Requerido</li>
                        <li>Formato number (Ej. 435)</li>
                    </ul>
                </li>
            </ul>
        </div>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/municipio/435</h5>
            <code>{
                "id": 435,
                "stateId": 11,
                "nombre": "GUANAJUATO",
                "stateCode": "11",
                "locationName": "GUANAJUATO",
                "locationCode": "01230006",
                "inegiLocationCode": "110150001",
                "activo": true
            }</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 2 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/municipio/3309</h5>
            <code>{
                "id": 3309,
                "stateId": 32,
                "nombre": "ZACATECAS",
                "stateCode": "32",
                "locationName": "ZACATECAS",
                "locationCode": "04656003",
                "inegiLocationCode": "320560001",
                "activo": true
            }</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 3 de Ejemplo, municipio no encontrado:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/municipio/33000</h5>
            <code>{}</code>
        </pre>
    </div>
</template>

<script>
export default {
    name: 'SepomexMunicipios',
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style scoped>
p {
    margin-bottom: 15px;
}
</style>
